import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SelectField } from "@/lib/crm";
import { ORDER_LINKS } from "@/lib/orders";
import { Button } from "@/components/ui/button";

const SOURCES = {
  asset: (cid) => api.get("/assets", { params: { company_id: cid, limit: 200 } }).then((r) => r.data.items.map((x) => ({ key: x.id, label: `${x.code} · ${x.name}` }))),
  license: (cid) => api.get("/licenses", { params: { company_id: cid } }).then((r) => r.data.items.map((x) => ({ key: x.id, label: `${x.code} · ${x.name}` }))),
  intervention: (cid) => api.get("/interventions", { params: { company_id: cid, limit: 100 } }).then((r) => r.data.items.map((x) => ({ key: x.id, label: `${x.number} · ${x.title}` }))),
  package: (cid) => api.get("/hour-packages", { params: { company_id: cid } }).then((r) => r.data.items.map((x) => ({ key: x.id, label: `${x.number} · ${x.name}` }))),
};
const PERM = { asset: "assets:read", license: "licenses:read", intervention: "interventions:read", package: "packages:read" };

export const OrderLinkForm = ({ order, onDone }) => {
  const { can } = useAuth();
  const kinds = Object.keys(SOURCES).filter((k) => can(PERM[k]));
  const [f, setF] = useState({ entity: kinds[0] || "asset", entity_id: "", line_id: "" });
  const [opts, setOpts] = useState([]);
  useEffect(() => { setOpts([]); SOURCES[f.entity]?.(order.company_id).then(setOpts).catch(() => setOpts([])); }, [f.entity, order.company_id]);
  const save = async () => {
    try { await api.post(`/orders/${order.id}/links`, { entity: f.entity, entity_id: f.entity_id, line_id: f.line_id || null }); toast.success("Collegamento aggiunto"); setF({ ...f, entity_id: "" }); onDone(); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <div className="mt-3 grid grid-cols-1 items-end gap-2 rounded-control bg-slate-50 p-3 sm:grid-cols-4" data-testid="order-link-form">
      <SelectField label="Tipo" value={f.entity} onChange={(e) => setF({ ...f, entity: e, entity_id: "" })} options={kinds.map((k) => ({ key: k, label: ORDER_LINKS[k] }))} testId="order-link-entity" />
      <SelectField label="Elemento" value={f.entity_id} onChange={(v) => setF({ ...f, entity_id: v })} options={opts} testId="order-link-target" />
      <SelectField label="Riga ordine" value={f.line_id} onChange={(v) => setF({ ...f, line_id: v })} options={order.lines.map((l) => ({ key: l.id, label: `${l.position}. ${l.description || l.name}` }))} allowNone="Intero ordine" testId="order-link-line" />
      <Button disabled={!f.entity_id} onClick={save} data-testid="order-link-save">Collega</Button>
    </div>
  );
};
